module.exports = __webpack_public_path__ + "img/galaxyDark.320c7cb9.jpg";